import { FC, useMemo } from 'react';
import { Popover } from 'antd';
import ArrowUp from '../../assets/icons/ArrowUp.svg';
import styles from './index.module.scss';
import { StatusEnum } from '../../assets/enums';
import { IOverviewPolicyTypes } from '../../types';
import { IEnum } from '../../services/type';

interface IProps {
  count: number;
  status: StatusEnum;
  policy_types: IOverviewPolicyTypes[];
  policyTypesEnum: IEnum[];
}

const StatusCard: FC<IProps> = ({
  count,
  status,
  policy_types,
  policyTypesEnum,
}) => {
  const colors: Record<StatusEnum, string> = {
    [StatusEnum.REQUEST_CREATED]: '#E59500',
    [StatusEnum.CANCEL_EXPECTED]: '#EC9596',
  };

  const titles: Record<StatusEnum, string> = {
    [StatusEnum.REQUEST_CREATED]: 'Talep Oluşturuldu',
    [StatusEnum.CANCEL_EXPECTED]: 'İptal Bekleniyor',
  };

  const sortedPolicyTypes = useMemo(
    () => [...(policy_types || [])].sort((a, b) => b.count - a.count),
    [policy_types],
  );

  const popoverContent = (
    <div className={styles.popoverContent}>
      {sortedPolicyTypes.length ? (
        <ul className={styles.popoverList}>
          {sortedPolicyTypes.map(({ policy_type, count }) => (
            <li key={policy_type} className={styles.popoverItem}>
              <span>
                {
                  policyTypesEnum.find(
                    (pte) => pte.key.toLowerCase() === policy_type,
                  )?.value
                }
              </span>
              <span>{count}</span>
            </li>
          ))}
        </ul>
      ) : (
        <div className={styles.empty}>Gösterilecek veri yok</div>
      )}
    </div>
  );

  return (
    <div
      style={{
        width: 150,
        border: '1px solid #A2ABB2',
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
      }}
    >
      <div
        style={{
          backgroundColor: colors[status],
          color: '#FFFFFF',
          textAlign: 'center',
          padding: '8px',
          borderTopLeftRadius: 6,
          borderTopRightRadius: 6,
        }}
      >
        {titles[status]}
      </div>

      <Popover
        overlayInnerStyle={{
          backgroundColor: '#001628',
          paddingLeft: 10,
          paddingRight: 10,
          paddingTop: 2,
          paddingBottom: 2,
        }}
        content={popoverContent}
        trigger="hover"
        placement="top"
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 18,
            gap: 4,
            cursor: sortedPolicyTypes.length ? 'pointer' : 'default',
          }}
        >
          <img src={ArrowUp} alt="ArrowUp" />
          <div className={styles.count}>{count}</div>
        </div>
      </Popover>
    </div>
  );
};

export default StatusCard;
